import Masonry from "masonry-layout";


var grid = document.querySelector(".js-masonry-content");
if(grid) {
  
  window.onload = function () {
    var msnry = new Masonry(grid, {
      // options...
      itemSelector: ".js-masonry-item",
    });
  };
}

